export const lastNameProperty = 'Nom du membre';
export const surnameProperty = 'Prénom du membre';
export const emailProperty = 'E-mail du membre';
export const planProperty = 'Plan';
export const organizationNameProperty = "Nom de l'organisation";
export const zipCodeProperty = "Code postal de l'organisation";
